import React from 'react'
import PropTypes from 'prop-types'

import StyledWrapper from './StyledWrapper'
import EditMembership from 'components_v2/Membership/Edit'

const EditMembershipWrapper = ({ user, ...rest }) => {
  return (
    <StyledWrapper user={user} mb='100px'>
      <EditMembership {...rest} />
    </StyledWrapper>
  )
}

EditMembershipWrapper.propTypes = {
  user: PropTypes.object
}

export default EditMembershipWrapper
